import React from 'react';

const VolunteerItem = ({ volunteer, onEdit, onDelete }) => {
  return (
    <div style={styles.item}>
      <div style={styles.name}>
        <span style={styles.nameText}>{volunteer.volunteerName || 'N/A'}</span>
      </div>
      <div style={styles.mobile}>{volunteer.mobile || 'N/A'}</div>
      <div style={styles.village}>{volunteer.village || 'N/A'}</div>
      <div style={styles.district}>
        {volunteer.district ? (
          <span style={styles.districtBadge}>{volunteer.district}</span>
        ) : (
          'N/A'
        )}
      </div>
      <div style={styles.status}>
        <span style={volunteer.status === 'Active' ? styles.statusActive : styles.statusInactive}>
          {volunteer.status || 'N/A'}
        </span>
      </div>
      <div style={styles.actions}>
        <button
          onClick={onEdit}
          style={styles.editButton}
          title="Edit Volunteer"
        >
          <span style={styles.buttonIcon}>✏️</span>
          <span style={styles.buttonText}>Edit</span>
        </button>
        <button
          onClick={onDelete}
          style={styles.deleteButton}
          title="Delete Volunteer"
        >
          <span style={styles.buttonIcon}>🗑️</span>
          <span style={styles.buttonText}>Delete</span>
        </button>
      </div>
    </div>
  );
};

const styles = {
  item: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 1fr',
    gap: '1rem',
    padding: '1rem',
    borderBottom: '1px solid var(--border-color)',
    alignItems: 'center',
    transition: 'background-color 0.2s',
    borderRadius: '4px',
    margin: '0.25rem 0',
  },
  name: {
    display: 'flex',
    alignItems: 'center',
  },
  nameText: {
    fontWeight: 'bold',
    color: 'var(--primary-color)',
  },
  mobile: {
    color: 'var(--text-color)',
  },
  village: {
    color: 'var(--text-color)',
  },
  district: {},
  status: {
    textAlign: 'center',
  },
  statusActive: {
    backgroundColor: '#4CAF50',
    color: 'white',
    padding: '0.25rem 0.5rem',
    borderRadius: '4px',
    fontSize: '0.85rem',
    fontWeight: '500',
  },
  statusInactive: {
    backgroundColor: '#F44336',
    color: 'white',
    padding: '0.25rem 0.5rem',
    borderRadius: '4px',
    fontSize: '0.85rem',
    fontWeight: '500',
  },
  districtBadge: {
    display: 'inline-block',
    padding: '0.25rem 0.5rem',
    backgroundColor: 'var(--secondary-light)',
    color: 'white',
    borderRadius: '4px',
    fontSize: '0.85rem',
    fontWeight: '500',
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    gap: '0.5rem',
  },
  editButton: {
    display: 'flex',
    alignItems: 'center',
    padding: '0.4rem 0.6rem',
    backgroundColor: 'var(--primary-light)',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    fontSize: '0.85rem',
  },
  deleteButton: {
    display: 'flex',
    alignItems: 'center',
    padding: '0.4rem 0.6rem',
    backgroundColor: 'var(--danger-color)',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    fontSize: '0.85rem',
  },
  buttonIcon: {
    marginRight: '0.3rem',
    fontSize: '0.9rem',
  },
  buttonText: {
    fontWeight: '500',
  },
};

export default VolunteerItem;
